export default "__VITE_PUBLIC_ASSET__18674a52__"